import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Consent, filterConsents, UserConsent } from '@icc/b2b/shared';
import { ConfigService } from '@icc/shared';

@Component({
    selector: 'icc-consent',
    templateUrl: './consent.component.html',
    styleUrls: ['./consent.component.scss'],
})
export class ConsentComponent {
    isCompanyAdmin = this.configService.user?.user?.ActiveCompanyAdmin;
    consent = this.configService.user?.consent;
    consents: Consent[] = [];
    oneConsent = false;
    areConsentsToAccept = false;

    constructor(
        private configService: ConfigService,
        private http: HttpClient,
        private router: Router,
        private sanitizer: DomSanitizer
    ) {
        this.consents = filterConsents(this.configService.user.consents, this.configService.user.acceptedConsents);

        this.oneConsent = this.consents.length === 1
            && this.consents[0].consentType === 'regulations';

        this.consents = this.consents
            .map((el) => {
                this.areConsentsToAccept =
                    this.areConsentsToAccept ||
                    el.forWho === 'user' ||
                    (el.forWho === 'company' && this.isCompanyAdmin);
                el.isAccepted = false;
                ['shortDescription', 'longDescription', 'info'].forEach((key) => {
                    if (el[key]) {
                        el[key] = this.sanitizer.bypassSecurityTrustHtml(el[key] as string);
                    }
                });
                return el;
            });
        if (!this.consents.length) {
            this.router.navigate(['trade']);
        }
    }

    async acceptConsents() {
        const response = await this.http.post<UserConsent[]>('/api/b2b/accept-consents', {
            consents: this.consents
        }).toPromise();
        if (response?.length) {
            this.configService.user.acceptedConsents = [...this.configService.user.acceptedConsents, ...response];
        }
        this.router.navigate(['trade']);
    }

    async acceptConsent() {
        const allConsents = this.consents.map(c => ({ ...c, isAccepted: true }));
        const response = await this.http.post<UserConsent[]>('/api/b2b/accept-consents', {
            consents: allConsents
        }).toPromise();
        if (response?.length) {
            this.configService.user.acceptedConsents = [...this.configService.user.acceptedConsents, ...response];
        }
        this.router.navigate(['trade']);
    }

    isButtonDisabled() {
        return !this.consents.every((el) => !el.required || (el.required && el.isAccepted));
    }
}
